<div class="pnl-coupon">
  <header>
    <div>
      <button (click)="onBack()" class="btn btn-primary-outline">Voltar</button>
      <button
        (click)="onCancelCoupon()"
        [disabled]="coupon == null"
        type="button"
        class="btn btn-primary-outline"
      >
        Cancelar
      </button>
      <button
        (click)="onSubmit()"
        type="button"
        [disabled]="!changeDetail"
        class="btn btn-primary"
      >
        Salvar
      </button>
    </div>
  </header>

  <form [formGroup]="couponFrm" (ngSubmit)="onSubmit()" novalidate>
    <section>
      <div class="pnl dados">
        <div>
          <strong>Código de desconto</strong>
          <label
            >Crie um código exclusivo para o cupom de desconto ou
            <a (click)="generateCode()">gere automaticamente</a></label
          >
          <input
            type="text"
            class="form-control"
            formControlName="codigo"
            (keyup)="onChangeCodigo()"
            placeholder="Exemplo: PROMOSUPER10"
            [class.error]="errorCode && !loadingCheck"
            [class.warning]="errorCode && loadingCheck"
          />
          <span *ngIf="errorCode && !loadingCheck" class="label-error"
            >Código de desconto já existente!</span
          >
        </div>

        <div>
          <strong>Desconto</strong>
          <label>Tipo de desconto</label>
          <div class="form-col-2">
            <ng-select
              placeholder="Selecione..."
              (change)="onChangeDetail()"
              formControlName="tipo_desconto"
              [items]="tipo_desconto_list"
              bindLabel="text"
              bindValue="value"
            ></ng-select>
            <div class="tipo_desconto">
              <input
                type="text"
                class="form-control"
                (keyup)="onChangeDetail()"
                [class.ti20]="tipo_desconto.value == 'F'"
                currencyMask
                [options]="{ precision: 2, allowNegative: false }"
                formControlName="desconto"
                placeholder="0"
              />
              <span class="valor" *ngIf="tipo_desconto.value == 'F'">R$</span>
              <span class="percentual" *ngIf="tipo_desconto.value == 'P'"
                >%</span
              >
            </div>
          </div>
        </div>

        <div>
          <strong>Atribuição</strong>
          <label>Atribuir o desconto para</label>
          <div class="form-col-2">
            <ng-select
              placeholder="Selecione..."
              formControlName="tipo_atribuicao"
              (change)="onChangeDetail()"
              [items]="tipo_atribuicao_list"
              bindLabel="text"
              bindValue="value"
            ></ng-select>
            <button
              *ngIf="tipo_atribuicao.value == 'P'"
              (click)="openModalProducts()"
              type="button"
              class="btn btn-primary-outline btn-tag"
            >
              <b *ngIf="produtos.length > 0">{{ produtos.length }}</b>
              Pesquisar produtos
            </button>
          </div>
        </div>

        <div>
          <strong>Requisito</strong>
          <label>Requisito para o desconto</label>
          <div class="form-col-2">
            <ng-select
              placeholder="Selecione..."
              formControlName="tipo_requisito"
              [items]="tipo_requisito_list"
              (change)="onChangeDetail()"
              bindLabel="text"
              bindValue="value"
            ></ng-select>
            <div class="tipo_desconto">
              <input
                *ngIf="
                  tipo_requisito.value != null && tipo_requisito.value != 'P'
                "
                [class.ti20]="tipo_requisito.value == 'V'"
                (keyup)="onChangeDetail()"
                type="text"
                class="form-control"
                formControlName="requisito"
                currencyMask
                [options]="configRequisito()"
                placeholder="0"
              />
              <span class="valor" *ngIf="tipo_requisito.value == 'V'">R$</span>
              <span class="percentual" *ngIf="tipo_requisito.value == 'Q'">{{
                requisito.value != 1 ? "Itens" : "Item"
              }}</span>
            </div>
          </div>
        </div>

        <div>
          <strong>Limite</strong>
          <label>Limite de cupons distribuídos</label>
          <div class="form-col-2 mb20">
            <ng-select
              placeholder="Selecione..."
              formControlName="tipo_limite_distribuidos"
              (change)="onChangeDetail()"
              [items]="tipo_limite_distribuidos_list"
              bindLabel="text"
              bindValue="value"
            ></ng-select>
            <div class="tipo_desconto">
              <input
                *ngIf="tipo_limite_distribuidos.value == 'L'"
                type="text"
                class="form-control"
                (keyup)="onChangeDetail()"
                formControlName="limite_distribuidos"
                currencyMask
                [options]="{ precision: 0, allowNegative: false }"
                placeholder="0"
              />
              <span
                class="percentual"
                *ngIf="tipo_limite_distribuidos.value == 'L'"
                >{{ limite_distribuidos.value != 1 ? "Itens" : "Item" }}</span
              >
            </div>
          </div>
          <label>Limite de uso por cliente</label>
          <div class="form-col-2">
            <ng-select
              placeholder="Selecione..."
              formControlName="tipo_limite_cliente"
              (change)="onChangeDetail()"
              [items]="tipo_limite_cliente_list"
              bindLabel="text"
              bindValue="value"
            ></ng-select>

            <div class="tipo_desconto">
              <input
                *ngIf="tipo_limite_cliente.value == 'L'"
                type="text"
                class="form-control"
                (keyup)="onChangeDetail()"
                formControlName="limite_cliente"
                currencyMask
                [options]="{ precision: 0, allowNegative: false }"
                placeholder="0"
              />
              <span
                class="percentual"
                *ngIf="tipo_limite_cliente.value == 'L'"
                >{{ limite_cliente.value != 1 ? "Itens" : "Item" }}</span
              >
            </div>
          </div>
        </div>

        <div>
          <strong>Validade</strong>
          <div class="form-col-2 mb20">
            <div>
              <label>Data de início</label>
              <div class="frm-datepicker">
                <input
                  type="text"
                  formControlName="dt_inicial"
                  class="form-control"
                  (dateInput)="onChangeDetail()"
                  [matDatepicker]="pickerInicialDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickerInicialDate"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #pickerInicialDate
                  [startAt]="startDate"
                ></mat-datepicker>
              </div>
            </div>
            <div>
              <label>Hora de início</label>
              <div class="hora_inicial">
                <input
                  type="text"
                  class="form-control"
                  matInput
                  formControlName="hora_inicial"
                  (keyup)="onChangeDetail()"
                  mask="Hh:m0"
                  [dropSpecialCharacters]="false"
                  placeholder="00:00"
                />
                <i class="ic ic-clock-gray"></i>
              </div>
            </div>
          </div>
          <mat-radio-group
            aria-label="Select an option"
            formControlName="flag_final"
            (change)="onChangeDetail()"
            class="mb20"
          >
            <mat-radio-button value="F"
              >O término ocorrerá apenas quando todos os cupons forem
              utilizados</mat-radio-button
            >
            <mat-radio-button value="D"
              >Definir uma data para expirar</mat-radio-button
            >
          </mat-radio-group>
          <div *ngIf="flag_final.value == 'D'" class="form-col-2">
            <div>
              <label>Data de expiração</label>
              <div class="frm-datepicker">
                <input
                  type="text"
                  formControlName="dt_expiracao"
                  [min]="dt_inicial.value"
                  (dateInput)="onChangeDetail()"
                  class="form-control"
                  [matDatepicker]="pickerExpiracaoDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickerExpiracaoDate"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #pickerExpiracaoDate
                  [startAt]="startDate"
                ></mat-datepicker>
              </div>
            </div>
            <div>
              <label>Hora de expiração</label>
              <div class="hora_expiracao">
                <input
                  type="text"
                  class="form-control"
                  formControlName="hora_expiracao"
                  (keyup)="onChangeDetail()"
                  matInput
                  mask="Hh:m0"
                  [dropSpecialCharacters]="false"
                  placeholder="00:00"
                />
                <i class="ic ic-clock-gray"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="graph">
        <div class="cupom-wrapper">
          <div class="cupom">
            <div class="descricao">
              <strong>{{ codigo.value }}</strong>
              <p *ngIf="dt_expiracao.value">
                {{ requisitoCupom() }}<br />
                {{
                  tipo_limite_cliente.value == "L"
                    ? limite_cliente.value + " cupom limitado por cliente"
                    : "cupom ilimitado por cliente"
                }}<br />
                Válido até
                {{
                  flag_final.value == "D"
                    ? (dt_expiracao.value.replace(" ", "T") | date: "dd/MM/y")
                    : "a promoção acabar"
                }}
              </p>
            </div>
            <div class="right">
              <span>CUPOM DE DESCONTO</span>
            </div>
            <i class="ic ic-stamp">
              <small *ngIf="tipo_desconto.value == 'F'">R$</small>
              <span>{{ desconto.value | number: "1.0-2" }}</span>
              <small *ngIf="tipo_desconto.value == 'P'">%</small>
            </i>
          </div>
        </div>
      </div>
    </section>
  </form>

  <div *ngIf="showModal" class="modal" [class.open]="openModal">
    <div class="modal-content modal-medium">
      <header>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="strSearch"
          (keydown)="resetPageSearch()"
          (keyup)="searchTerm$.next($event.target.value)"
          placeholder="Buscar produtos..."
        />
        <i class="ic ic-magnifying"></i>
        <a class="btn-close dnone"></a>
      </header>
      <section
        infiniteScroll
        [infiniteScrollDistance]="2"
        [scrollWindow]="false"
        [infiniteScrollThrottle]="20"
        (scrolled)="onScroll()"
      >
        <div
          *ngFor="let product of products; let i = index"
          [class.active]="product.selected"
          (click)="selectProduct(product)"
        >
          <figure>
            <img
              [src]="product.image"
              onerror="this.onerror=null;this.src='/assets/img/produto_sem_foto.png'"
            />
            <b class="check"></b>
          </figure>
          <div class="description">
            <span>{{ product.descricao }}</span>
            <strong>{{ product.codbarra | mask: "0 000000 000000" }}</strong>
          </div>
          <div class="price">R$ {{ product.preco | number: ".2" }}</div>
        </div>

        <div
          class="loading"
          *ngIf="loadingProducts"
          [class.loading-inital]="page == 1"
        >
          <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
            <div class="ldio-ns36390yc">
              <div></div>
            </div>
          </div>
        </div>
      </section>
      <footer>
        <span>{{ produtosSelected.length + produtos.length }} selecionado</span>
        <button
          (click)="closeModalProducts()"
          type="button"
          class="btn btn-primary-outline"
        >
          CANCELAR
        </button>
        <button (click)="putProducts()" type="button" class="btn btn-primary">
          ATRIBUIR
        </button>
      </footer>
    </div>
  </div>

  <div class="loading" *ngIf="loading">
    <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
      <div class="ldio-ns36390yc">
        <div></div>
      </div>
    </div>
  </div>
</div>
